var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { CoopConstants } from "../../constants/CoopConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectCoop, selectCoopPointsToCollect, selectCoopProjectPoints, selectCoopSendLoyaltyCooldownEndTime, } from "../../selectors/selectCoopInfo";
import { selectInventoryResourceInfo } from "../../selectors/selectInventoryInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilNumber } from "../../utils/utilNumber";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalSwapLast, actionModalTabSelect } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdStoreCategory } from "../store/IdStoreCategory";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { actionCoopCollectPoints, actionCoopPointsInfoRequest, actionCoopSendPoints, } from "./actionCoop";
import { CoopHelpInfo } from "./help/CoopHelpInfo";
import { CoopHelpMembersPoints } from "./help/CoopHelpMembersPoints";
import { CoopSendPoints } from "./help/CoopSendPoints";
var TabCoopHelpDOM = /** @class */ (function (_super) {
    __extends(TabCoopHelpDOM, _super);
    function TabCoopHelpDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.tableHeaders = [utilLoca.get(IdLoca.rankingMenu_name)];
        _this.getTableRows = function () {
            var rows = [React.createElement("div", { className: "tr", key: "member-point" })];
            var _a = _this.props, pointsToCollect = _a.pointsToCollect, projectPoints = _a.projectPoints;
            if (projectPoints) {
                rows.push(React.createElement("div", { className: IdStyles.TableRowCoopHelp + " selected tr " + IdStyles.TextNormal, key: "project-points" },
                    React.createElement("div", { className: "td td--coop-loyalty-name coop-help-member-name" }, utilLoca.get(IdLoca.bestProjectContribution)),
                    React.createElement("div", { className: "td__divider" }),
                    React.createElement("div", { className: "td" },
                        React.createElement(NumberFormat, { amount: projectPoints }))));
            }
            pointsToCollect.forEach(function (point) {
                rows.push(React.createElement("div", { className: IdStyles.TableRowCoopHelp + " tr " + IdStyles.TextNormal, key: "member-point_" + point.playerId },
                    React.createElement("div", { className: "td td--coop-loyalty-name coop-help-member-name" }, point.name),
                    React.createElement("div", { className: "td__divider" }),
                    React.createElement("div", { className: "td" },
                        React.createElement(NumberFormat, { amount: point.amount || 0 }))));
            });
            return rows;
        };
        _this.getTableHeaders = function () {
            var headers = [];
            _this.tableHeaders.forEach(function (head, index) {
                var colClassName = head === utilLoca.get(IdLoca.rankingMenu_name) ? "td--coop-loyalty-name" : "";
                headers.push(React.createElement(React.Fragment, { key: "th-" + index },
                    React.createElement("div", { className: "td " + colClassName }, head),
                    React.createElement("div", { className: "td__divider" })));
            });
            headers.push(React.createElement(React.Fragment, { key: "th-" + _this.tableHeaders.length },
                React.createElement("div", { className: "td" },
                    React.createElement(Icon, { icon: IdIcon.LoyaltyPointsIcn, styleId: IdStyles.IconSmall }))));
            return headers;
        };
        var _a = _this.props, coopPointsInfo = _a.coopPointsInfo, coopId = _a.coopId, playerId = _a.playerId;
        if (coopId) {
            coopPointsInfo(playerId, coopId);
        }
        return _this;
    }
    TabCoopHelpDOM.prototype.render = function () {
        var coopId = this.props.coopId;
        if (!coopId) {
            return React.createElement(React.Fragment, null);
        }
        var _a = this.props, loyaltyPoints = _a.loyaltyPoints, pointsToCollect = _a.pointsToCollect, onCollectCoopPoints = _a.onCollectCoopPoints, playerId = _a.playerId, cooldownEndTime = _a.cooldownEndTime, onSendCoopPoints = _a.onSendCoopPoints, onGoToShopClick = _a.onGoToShopClick, projectPoints = _a.projectPoints;
        var totalPoints = pointsToCollect
            .map(function (point) { return point.amount; })
            .reduce(function (prev, next) {
            var prevNumber = parseInt(utilNumber.format(prev || Long.ZERO), 10);
            var nextNumber = parseInt(utilNumber.format(next || Long.ZERO), 10);
            return Long.fromNumber(prevNumber + nextNumber);
        }, Long.ZERO);
        var totalPointsWithProject = (totalPoints || Long.ZERO).add(projectPoints || Long.ZERO);
        var isCollectDisabled = pointsToCollect.length === 0 && !projectPoints;
        var collectBtnDOM = isCollectDisabled ? (React.createElement(TooltipText, { id: IdLoca.floatingText_noPointsToCollect, anchor: IdTooltipAnchor.Bottom },
            React.createElement(ButtonPrimary, { disabled: true },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })))) : (React.createElement(ButtonPrimary, { onClick: function () { return onCollectCoopPoints(playerId, coopId); } },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })));
        return (React.createElement("div", { className: "coop-help-container flex flex--spaced" },
            React.createElement(CoopHelpInfo, { loyaltyPoints: loyaltyPoints, onGoToShopClick: onGoToShopClick }),
            React.createElement("div", { className: "flex flex--stacked flex--spaced" },
                React.createElement(CoopHelpMembersPoints, { rows: this.getTableRows(), headers: this.getTableHeaders(), totalPoints: totalPointsWithProject }),
                React.createElement("div", { className: "flex flex--spaced" },
                    React.createElement("div", { className: "flex flex--stacked" }),
                    React.createElement(CoopSendPoints, { coopId: coopId, cooldownEndTime: cooldownEndTime, playerId: playerId, onSendCoopPoints: onSendCoopPoints }),
                    collectBtnDOM))));
    };
    return TabCoopHelpDOM;
}(React.Component));
var mapState = function (state) {
    var coop = selectCoop(state);
    var loyaltyPointsResource = selectInventoryResourceInfo(state, CoopConstants.LoyaltyPointsResourceId);
    var loyaltyPoints = loyaltyPointsResource && loyaltyPointsResource.amount
        ? loyaltyPointsResource.amount
        : Long.ZERO;
    return {
        cooldownEndTime: selectCoopSendLoyaltyCooldownEndTime(state),
        coopId: coop ? coop.id : undefined,
        loyaltyPoints: loyaltyPoints,
        playerId: selectPlayerInfo(state).playerId,
        pointsToCollect: selectCoopPointsToCollect(state),
        projectPoints: selectCoopProjectPoints(state),
    };
};
var mapDispatch = function (dispatch) { return ({
    coopPointsInfo: function (playerId, coopId) {
        return dispatch(actionCoopPointsInfoRequest(playerId, coopId));
    },
    onCollectCoopPoints: function (playerId, coopId) {
        return dispatch(actionCoopCollectPoints(playerId, coopId));
    },
    onGoToShopClick: function () {
        dispatch(actionModalSwapLast(IdModal.Store));
        dispatch(actionModalTabSelect(IdStoreCategory.LoyaltyPackages));
    },
    onSendCoopPoints: function (playerId, coopId) {
        return dispatch(actionCoopSendPoints(playerId, coopId));
    },
}); };
export var TabCoopHelp = connect(mapState, mapDispatch)(TabCoopHelpDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/TabCoopHelp.tsx
// module id = 2601
// module chunks = 3